module.exports = __webpack_public_path__ + "img/cooperate_21.cbdc7b54.png";